import React from 'react';
import { XIcon, CheckIcon, ArrowDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TransformCta } from '../TransformCta';
import { beforeItems, afterItems } from '../../data/problem';
export function BeforeAfter() {
  return <section className="bg-ink py-16 sm:py-24" aria-labelledby="ba-title" data-id="element-97" data-mp="22krcpnie529n">
      <div className="mx-auto max-w-6xl px-5" data-id="element-98" data-mp="22mlvowa3qkb3">
        <SectionHeading kicker="A better way to approach HVAC electrical faults" title={<span id="ba-title" data-id="element-100" data-mp="2ubfen1rw2bod">From random electrical checks to structured troubleshooting</span>} data-id="element-99" data-mp="2zbjt6m98kwby" />

        <div className="mt-12 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-101" data-mp="2q9kazqmhjm7f">
          <div className="rounded-3xl border-2 border-danger/50 bg-danger/[0.06] p-6 sm:p-8" data-id="element-102" data-mp="2lb90resa39oo">
            <p className="inline-flex rounded-lg bg-danger px-3 py-1 font-display text-xl font-extrabold uppercase text-white" data-id="element-103" data-mp="1ev6s706l9wy9">
              Before
            </p>
            <h3 className="mt-3 font-display text-3xl font-bold uppercase text-white" data-id="element-104" data-mp="19uiszr87i9sy">Unstructured troubleshooting</h3>
            <ul className="mt-6 space-y-4" data-id="element-105" data-mp="1739leny8szzk">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[17px] leading-snug text-mist" data-id="element-106" data-mp="1c3nvscnbgm0r">
                  <XIcon className="mt-0.5 h-6 w-6 shrink-0 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-107" data-mp="y6sb1mxpd64v" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center lg:hidden" aria-hidden="true" data-id="element-108" data-mp="ocrzp3btv4np">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-amber" data-id="element-109" data-mp="t75vv7ybdftf">
              <ArrowDownIcon className="h-6 w-6 text-ink" strokeWidth={3} data-id="element-110" data-mp="ffrd928bjgmw" />
            </span>
          </div>

          <div className="rounded-3xl border-2 border-ok/60 bg-ok/[0.07] p-6 sm:p-8" data-id="element-111" data-mp="jg1k0h3xqb2t">
            <p className="inline-flex rounded-lg bg-ok px-3 py-1 font-display text-xl font-extrabold uppercase text-ink" data-id="element-112" data-mp="5ginymoeeq6v">
              After
            </p>
            <h3 className="mt-3 font-display text-3xl font-bold uppercase text-white" data-id="element-113" data-mp="2c4sr60i0jjvv">HVAC Electrical Fault Pathway™</h3>
            <ul className="mt-6 space-y-4" data-id="element-114" data-mp="27chquwjd1w2s">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[17px] font-medium leading-snug text-white" data-id="element-115" data-mp="23b5zalgxf0ry">
                  <CheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-116" data-mp="1ydxhwn3lr0rr" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-3xl text-center" data-id="element-117" data-mp="2r21l91ypb1ra">
          <h3 className="font-display text-4xl font-extrabold uppercase text-volt sm:text-5xl" data-id="element-118" data-mp="2m1noig2jve8k">The transformation</h3>
          <p className="mt-4 text-pretty text-xl font-semibold leading-snug text-white" data-id="element-119" data-mp="2h2atv95ft2vf">
            Go from scattered electrical observations to one organized troubleshooting record with five clearly defined
            stages.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-mist" data-id="element-120" data-mp="15qjq13ergvei">
            No guessing what the next administrative step should be. No relying on memory to reconstruct your
            investigation. Just a structured process for qualified professionals to apply alongside approved technical
            and safety procedures.
          </p>
        </div>

        <TransformCta label="Take me from scattered to structured" data-id="element-121" data-mp="1a9y4tvyunsqf" />
      </div>
    </section>;
}